import { SlashCircleFill } from "react-bootstrap-icons";

export default function SlashCircleFillReversed(props: { title?: string; label?: string; className?: string }) {
  const className = props.className ?? "" + " flip-horizontal";
  return <SlashCircleFill color="red" title={props.title} aria-label={props.label} className={className} />;
}
